import React from 'react'

import {
  Box,
  CircularProgress,
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
  Typography,
} from '@material-ui/core'
import { isEmpty } from 'lodash'

import { QuestionnaireCheckbox } from './components'

import useFetch from 'hooks/useFetch'

import * as service from 'service'

const QuestionnaireForm = ({
  selectedQuizTemplates = [],
  setSelectedQuizTemplates,
  linkedQuestionnaires = [],
  isShow = false,
  isPreAvaliation = false,
}) => {
  const { response, isLoading } = useFetch(
    service.dponet.supplierQuizTemplates.list,
    { perPage: 20 },
    [],
  )

  const quizTemplates = response?.data?.quizTemplates || []

  const availableQuizTemplates = quizTemplates.sort(
    (a, b) => (b.isMandatory ? 1 : 0) - (a.isMandatory ? 1 : 0),
  )

  const inactiveQuestionnaires = linkedQuestionnaires.filter(
    (companySupplierQuestionnaire) =>
      companySupplierQuestionnaire.inactivated ||
      companySupplierQuestionnaire.belongsToOrganization === false,
  )

  const toggleQuizTemplate = (quizTemplateId) => {
    setSelectedQuizTemplates((prev) =>
      prev.includes(quizTemplateId)
        ? prev.filter((id) => id !== quizTemplateId)
        : [...prev, quizTemplateId],
    )
  }

  const handleChange = (quizTemplate) => {
    return quizTemplate.isMandatory
      ? () => {}
      : () => toggleQuizTemplate(quizTemplate.id)
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {isLoading ? (
          <Box
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            p={4}
          >
            <CircularProgress color="primary" />
          </Box>
        ) : (
          <>
            {isEmpty(availableQuizTemplates) &&
            isEmpty(inactiveQuestionnaires) ? (
              <Box>
                <Typography variant="body1" color="textSecondary">
                  Não foram encontrados questionários para fornecedor vinculados
                  a sua empresa, contate o encarregado de dados responsável em
                  canal de atendimento.
                </Typography>
              </Box>
            ) : (
              <Grid container spacing={3}>
                {!isEmpty(availableQuizTemplates) && (
                  <Grid item xs={12}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">
                        Selecione quais questionários o{' '}
                        {isPreAvaliation ? 'pré avaliado' : 'fornecedor'} deverá
                        responder
                      </FormLabel>

                      <Box mt={2}>
                        <FormGroup>
                          {availableQuizTemplates.map((quizTemplate) => (
                            <QuestionnaireCheckbox
                              key={quizTemplate.id}
                              quizTemplate={quizTemplate}
                              checked={
                                quizTemplate.isMandatory ||
                                selectedQuizTemplates.includes(quizTemplate.id)
                              }
                              onChange={handleChange(quizTemplate)}
                              isMandatory={quizTemplate.isMandatory}
                              disabled={isShow}
                            />
                          ))}
                        </FormGroup>
                      </Box>
                    </FormControl>
                  </Grid>
                )}

                {!isEmpty(inactiveQuestionnaires) && (
                  <Grid item xs={12}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">
                        Questionários vinculados que foram inativados pelo
                        encarregado de dados ou que pertenciam a um encarregado
                        anterior
                      </FormLabel>

                      <Box mt={2}>
                        <FormGroup>
                          {inactiveQuestionnaires.map(
                            (companySupplierQuestionnaire) => {
                              const quizTemplateId =
                                companySupplierQuestionnaire.questionnaire
                                  ?.quizTemplateId

                              return (
                                <QuestionnaireCheckbox
                                  key={companySupplierQuestionnaire.id}
                                  quizTemplate={{
                                    id: quizTemplateId,
                                    kind: companySupplierQuestionnaire
                                      .questionnaire?.kind,
                                  }}
                                  checked={selectedQuizTemplates.includes(
                                    quizTemplateId,
                                  )}
                                  onChange={() =>
                                    toggleQuizTemplate(quizTemplateId)
                                  }
                                  disabled={isShow}
                                />
                              )
                            },
                          )}
                        </FormGroup>
                      </Box>
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            )}
          </>
        )}
      </Grid>
    </Grid>
  )
}

export default QuestionnaireForm
